import { useEffect, useState } from "react";
import SearchableSingleSelectDropdown from "../SearchableDropdown/searchableSingleSelectDropdown";
import { getAllObjects, getObject } from "../../services/apiService";
import SelectFieldsPanel from "../SelectFieldsPanel/selectFieldsPanel";
import { useAppDispatch, useAppSelector } from "../../redux/stateHooks";
import {
  getObjectName,
  setObjectDetails,
} from "../../redux/reducers/objectSlice";

function LoadTable() {
  const [allObjects, setAllObjects] = useState([]);
  const dispatch = useAppDispatch();
  const ObjectName = useAppSelector(getObjectName);

  const fetchObjects = async () => {
    let resp = await getAllObjects();
    setAllObjects(resp?.data || []);
  };
  const fetchSingleObject = async (objectName) => {
    let { data: _selectedObject } = await getObject(objectName);
    dispatch(setObjectDetails({ objectName, ..._selectedObject }));
  };
  useEffect(() => {
    // console.log("calling...1")
    fetchObjects();
  }, []);
  useEffect(() => {
    if (ObjectName) fetchSingleObject(ObjectName);
  }, [ObjectName]);

  return (
    <>
      <div className="d-flex items-center searchBox">
        <span className="selectObj">Select Object:</span>
        <div className="custom-dropdown">
          <SearchableSingleSelectDropdown options={allObjects} />
        </div>
      </div>
      <div className="cnt-space cnt-space-height">
        <SelectFieldsPanel />
      </div>
    </>
  );
}

export default LoadTable;
